<template>
    <v-card tile height="100%" class="pa-5">
        <v-img v-if="card.image" :aspect-ratio="16/9" height="auto" width="100%" :src="card.image" contain></v-img>
        <v-card-title v-if="card.title">
            {{ card.title }}
        </v-card-title>
        <v-card-text v-if="card.text">
            <div v-html="card.text"></div>
        </v-card-text>
        <v-card-actions v-if="card.copyToClipboard || card.buttonText" class="pt-8">
            <div :style="computedButtonsAlignment" class="actions-container">
                <v-btn v-if="card.buttonText" depressed color="q_green_2" dark @click="clicked(card.buttonHref, card.newWindow)">
                    <strong>{{ card.buttonText }}</strong>
                </v-btn>
                <v-btn v-if="card.copyToClipboard" class="truncate-btn" text small v-clipboard:copy="card.copyToClipboard" v-clipboard:success="handleCopyStatus">
                    <span class="truncate-content">{{ card.copyText }}</span>
                </v-btn>
            </div>
        </v-card-actions>
    </v-card>
</template>

<script>
const flexJustifyContent = {
	left: 'flex-start',
	center: 'center',
	right: 'flex-end',
}

export default {
    props: {
        card: {
            type: Object,
            default: function() {
                return {
                    title: null,
                    text: null,
                    buttonText: null,
                    buttonHref: null,
                    newWindow: null,
                    image: null,
                    copyText: null,
                    copySucceeded: null,
                    copyToClipboard: null,
					buttonAlignment: 'left',
                }
            }
        }
    },
    computed: {
        computedButtonsAlignment() {
			return `justify-content:${flexJustifyContent[this.card.buttonAlignment || 'left']}`
        },
    },
    methods: {
        clicked: function(href, newWindow) {
            if (href.indexOf('http') > -1) {
                if (href.indexOf('quility.com') > -1 && newWindow != "_blank") {
                    document.location = href
                } else {
                    window.open(href, newWindow);
                }
            } else {
                this.$router.push(href)
            }
        },
        handleCopyStatus() {
            this.showInfo("Copied to clipboard")
        },
    }
}
</script>

<style lang="scss" scoped>
.actions-container {
	position: absolute;
	left:0;
	bottom:0;
	padding: 20px;
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	gap: 0.25rem 0.5rem;
}

.truncate-btn {
	max-width: 100%;

	::v-deep .v-btn__content {
		max-width: 100%;
	}
}

.truncate-content {
	display: inline-block;
	max-width: 100%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
